$(function () {
    $("[data-datePicker]").flatpickr({
        enableTime: false,
        noCalendar: false,
        dateFormat: "d.m.Y",
        minDate: 'today',
        locale: getLang(),
        nextArrow: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 19'><path fill-rule='evenodd' d='M2.446 0L0 2.376 7.2 9.5 0 16.626 2.446 19 12 9.5z'/></svg>",
        prevArrow: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 19'><path fill-rule='evenodd' d='M9.554 0L12 2.376 4.8 9.5l7.2 7.125L9.554 19 0 9.5z'/></svg>",
    });
});